import { render, staticRenderFns } from "./appIndex.vue?vue&type=template&id=5bcc7454&scoped=true&"
import script from "./appIndex.vue?vue&type=script&lang=js&"
export * from "./appIndex.vue?vue&type=script&lang=js&"
import style0 from "./appIndex.vue?vue&type=style&index=0&id=5bcc7454&lang=less&scoped=true&"
import style1 from "./appIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc7454",
  null
  
)

export default component.exports